import { render, staticRenderFns } from "./CardsSearch.vue?vue&type=template&id=05a460a2&"
import script from "./CardsSearch.vue?vue&type=script&lang=js&"
export * from "./CardsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports